import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormControl, Validators} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./delete-confirmation.component.scss']
})
export class DeleteConfirmationComponent implements OnInit {

  public confirmationFormControl: UntypedFormControl;
  public confirmationText: string;
  public deletedItem: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {
  }

  ngOnInit(): void {
    this.deletedItem = this.data || 'resource';
    this.confirmationText = 'delete me';
    this.confirmationFormControl = new UntypedFormControl(null, [Validators.required, Validators.pattern(this.confirmationText)]);
  }


  verify(): boolean {
    if (this.confirmationFormControl.valid) {
      return this.confirmationFormControl.value === this.confirmationText;
    }
    return false;
  }

  confirm(): void {
    if (this.confirmationFormControl.valid) {
      if (this.verify()) {
        this.dialogRef.close(true);
      } else {
        this.confirmationFormControl.reset();
      }
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
